// extracted by mini-css-extract-plugin
module.exports = {"button":"back-arrow-module--button--1A8s4","svg":"back-arrow-module--svg--33KI7","path":"back-arrow-module--path--1IU9I"};